import { useState } from "react";
import { HighlightOff } from '@mui/icons-material';
import FutureOrderPicker from './FutureOrderPicker';

// פופאפ "החלף מועד" - עוטף FutureOrderPicker עם state עצמאי משלו, כדי
// שהבחירה תתעדכן ריאקטיבית (הרכיב שמחזיק את הפופאפ ב-thePopUp לא בהכרח
// נבנה מחדש עם כל state חיצוני). props:
// rest, master, channel - מועברים כמו שהם ל-FutureOrderPicker
// initialSlot - Date|null, המועד הנוכחי של ההזמנה (אם קיים)
// onConfirm(slot) - קרוי עם ה-Date הנבחר בלחיצה על "אישור"
// onClose() - קרוי בסגירה (X או לחיצה מחוץ לתוכן) בלי לאשר
const ChangeScheduledForPopup = (props) => {

    const [selectedSlot, setSelectedSlot] = useState(props.initialSlot || null);

    return (
        <div className={"futureTimePopupOverlay"} onClick={() => props.onClose()}>
            <div className={"futureTimePopupInner"} onClick={(e) => e.stopPropagation()}>
                <button type="button" className={"btnReset sideClosBtn halfspin"} aria-label="סגור"
                    onClick={() => props.onClose()}>
                    <HighlightOff aria-hidden="true" />
                </button>
                <FutureOrderPicker
                    rest={props.rest}
                    master={props.master}
                    channel={props.channel}
                    selectedSlot={selectedSlot}
                    onSelect={(slot) => setSelectedSlot(slot)}
                    onConfirm={() => props.onConfirm(selectedSlot)}
                />
            </div>
        </div>
    );
}

export default ChangeScheduledForPopup;
